export const usd = (
  amount: number | null | undefined,
  options: { symbol?: boolean } = {}
): string | undefined => {
  if (amount === undefined || amount === null) {
    return undefined
  }

  const { symbol = true } = options
  const styleOptions = symbol
    ? { style: 'currency', currency: 'USD' }
    : { minimumFractionDigits: 2 }

  return (amount / 100).toLocaleString('en-US', styleOptions)
}

export const displayPercentage = (rate: number): string | undefined => {
  if (rate === undefined || rate === null) {
    return undefined
  }

  return rate / 1000 + '%'
}

/**
 * Converts a string dollar price with decimals to a number of cents, which is
 * how prices are stored in the api.
 */
export const formatPriceToCents = (price: string): number => {
  return Math.round(Number(price) * 100)
}
